import { BrandCode } from '../../curriculum';
import { grantTrialLicenses } from '../api/grantTrialLicense';
import { grantTrialLicensesFromCode } from '../api/grantTrialLicensesFromCode';
import { Item } from '../models/datastore';

export const grantPreviewLicenses = (
  items: Item[],
  userId: string,
  orgId: string,
  zipCode: string,
  brandCode: BrandCode
) => {
  return grantTrialLicenses(
    items.map(item => item.itemNumber ?? ''),
    userId,
    orgId,
    zipCode,
    userId
  );
};

export const grantTrialLicensesFromTrialCode = (
  items: Item[],
  userId: string,
  orgId: string,
  zipCode: string,
  brandCode: BrandCode
) => {
  const requestedAgeGroups = items.map(item => item.name);
  return grantTrialLicensesFromCode(userId, orgId, zipCode, userId, brandCode, requestedAgeGroups);
};
